<div class="input-with-label" [ngClass]="{ 'display-row': displayInRow }">
  <label *ngIf="label" [for]="label" class="d-flex align-items-center"
    >{{ label | translate }}
    <span class="text-danger px-1" *ngIf="isMandatory"> * </span>

    <strong
      [ngClass]="{ 'active-icon': value }"
      class="px-2"
      (click)="labelIconClicked.emit()"
      [class]="labelIcon">
    </strong>
  </label>
  <!-- <select
    (change)="onDropdownChange()"
    [disabled]="disabled"
    [(ngModel)]="value"
    [id]="label"
    class="form-select form-select-sm"
    aria-label=".form-select-sm example"
    [ngClass]="{ 'placeholder-color': value === null }">
    <option class="intial-option" [value]="null" selected>
      {{ placeholder | translate }}
    </option>
    <ng-container *ngIf="options">
      <option *ngFor="let opt of options" [value]="opt[optionValue]">
        {{ opt[optionLabel] }}
      </option>
    </ng-container>
  </select> -->

  <p-dropdown 
    [options]="options"
    [disabled]="disabled"
    [(ngModel)]="value" 
    optionLabel="name" 
    optionValue="id"
    [id]="label"
    (onChange)="onDropdownChange()"
    placeholder="{{ placeholder | translate }}" />
</div>

<!-- {{options |json}} -->
